import {Meta} from "@unhead/vue";

interface MetaCouple {
    name: string
    content: string
}

class UseHeadService {
    set ogurl(value: string) {
        this._ogurl = value;
    }
    set title(value: string) {
        this._title = value;
    }
    set description(value: string) {
        this._description = value;
    }

    private _description : string = ''
    private _title : string = ''
    private _ogurl : string = ''

    getMetaTitle() : MetaCouple {
        return {
            name: 'title',
            content: this._title,
        }
    }
    getMetaOGTitle() : MetaCouple {
        return {
            name: 'og:title',
            content: this._title,
        }
    }
    getMetaOGDescription() : MetaCouple {
        return {
            name: 'og:description',
            content: this._description,
        }
    }
    getMetaDescription(): MetaCouple {
        return {
            name: 'description',
            content: this._description,
        }
    }
    getMetaOGUrl() : MetaCouple {
        return {
            name: 'og:url',
            content: this._ogurl,
        }
    }

    getMetaNoIndex() : MetaCouple {
        return {
            name: 'robots',
            content: 'noindex, follow'
        }
    }
    getMetaInfo(norobots : boolean = false) : [] {
        let metaInfo : MetaCouple[] = [
            {
                name: 'charset',
                content: 'utf-8'
            },
            {
                name: 'theme-color',
                content: '#fff'
            },
            {
                name: 'og:type',
                content: 'article'
            },
            {
                name: 'og:site_name',
                content: 'Моды для Assetto Corsa, BeamNG Drive - Mod-Box.ru'
            }
        ]

        metaInfo.push(
            this.getMetaDescription(),
            this.getMetaTitle(),
            this.getMetaOGDescription(),
            this.getMetaOGTitle(),
            this.getMetaOGUrl()
        )

        if(norobots) metaInfo.push(this.getMetaNoIndex())
        return metaInfo as []
    }
}

export default new UseHeadService()